<template>
	<section class="flex-module container-fluid flexible-text-columns">
		<div class="row">
			<div class="col-xs-12">
				<h2 class="section-title">
					{{ item.title }}
				</h2>
			</div>
		</div>

		<div class="row content">
			<div v-for="col in item.columns"
				 :key="col.id"
				 :ref="setItemRef"
				 class="col-xs-12 col-md-6 col-lg-4 text-column ">

				<h2 class="column-title so-reveal">
					{{ col.title }}
				</h2>

				<BaseRichText :data="col.body"
							  class="so-reveal" />
			</div>
		</div>
	</section>
</template>

<script setup>
const props = defineProps({
	data: {
		type: Object,
		required: true,
	},
})

let itemRefs = []

const item = computed(() => props.data?.item)

const setItemRef = el => {
	if (el) {
		itemRefs.push(el)
	}
}

onBeforeUpdate(() => {
	itemRefs = []
})
</script>

<style lang="scss" scoped>
.text-column {
	margin-bottom: rem-calc(72);

	@include for-devices-above(md) {
		margin-bottom: rem-calc(100);
	}

	@include for-devices-above(lg) {
		margin-bottom: 0;
	}

	h2.column-title {
		@include textH6;
		margin-top: 0;
		margin-block-end: 50px;
	}

	// h1,
	// h2,
	// h3,
	// h4,
	// h5,
	// h6 {
	// overflow: hidden;
	// }
}
</style>
